// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.side-fixed[data-v-43269699] {\n  height: calc(100vh - 70px);\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
